module.exports = __webpack_public_path__ + "img/Fornax.845364bb.png";